/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperationalGoldenLinkBackfillRequest
 */
export interface OperationalGoldenLinkBackfillRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof OperationalGoldenLinkBackfillRequest
     */
    entityTypes?: Array<string>;
}

/**
 * Check if a given object implements the OperationalGoldenLinkBackfillRequest interface.
 */
export function instanceOfOperationalGoldenLinkBackfillRequest(value: object): value is OperationalGoldenLinkBackfillRequest {
    return true;
}

export function OperationalGoldenLinkBackfillRequestFromJSON(json: any): OperationalGoldenLinkBackfillRequest {
    return OperationalGoldenLinkBackfillRequestFromJSONTyped(json, false);
}

export function OperationalGoldenLinkBackfillRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationalGoldenLinkBackfillRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'entityTypes': json['entityTypes'] == null ? undefined : json['entityTypes'],
    };
}

export function OperationalGoldenLinkBackfillRequestToJSON(json: any): OperationalGoldenLinkBackfillRequest {
    return OperationalGoldenLinkBackfillRequestToJSONTyped(json, false);
}

export function OperationalGoldenLinkBackfillRequestToJSONTyped(value?: OperationalGoldenLinkBackfillRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityTypes': value['entityTypes'],
    };
}

